import React from 'react';
import { RequestFormValidatedState } from '@interfaces/RequestForm/forms/RequestFormValidatedState';
import {
	AttachmentPayload, useUploadDocumentsAndSubmitWithPayload
} from '@data/documentSignedUrl/hooks/useUploadDocumentsAndSubmitWithPayload/useUploadDocumentsAndSubmitWithPayload';
import { useSsmUiFlags } from '@utilities/hooks/useSsmUiFlags/useSsmUiFlags';

interface UseSubmitSurgeryRequestProps {
	appointmentLocation: string;
	saveAuthenticatedForm: (formResults: RequestFormValidatedState) => void;
	attachments?: AttachmentPayload[],
}

export const useConditionalSurgeryRequestSubmit = ({ appointmentLocation, saveAuthenticatedForm, attachments }: UseSubmitSurgeryRequestProps) => {
	const { ssmuiSignedUrl } = useSsmUiFlags();
	const { uploadDocs } = useUploadDocumentsAndSubmitWithPayload(appointmentLocation);

	return React.useCallback((formResults: RequestFormValidatedState) => {
		if (!ssmuiSignedUrl || !formResults.documents || !Object.keys(formResults.documents).length) {
			saveAuthenticatedForm(formResults);
		} else {
			const transformPrevAttachments = (attachments || []).map(({ id, file }) => ({ id, file }));

			uploadDocs(formResults.documents, (attachmentPayload: AttachmentPayload[]) => {
				return saveAuthenticatedForm({
					...formResults,
					attachments: attachmentPayload.concat(transformPrevAttachments),
				});
			});
		}
	}, [attachments, saveAuthenticatedForm, ssmuiSignedUrl, uploadDocs]);
};
